import ServiceGraphQL from 'src/service/gql-service';
import { applyFatZebra } from 'src/graphql';

const serviceGraphQL = new ServiceGraphQL();

/** Action creators */
export const ApplyFatZebra = (data) => {
  const params = {
    query: applyFatZebra.QUERY,
    variables: {
      ...data
    }
  };
  return serviceGraphQL
    .post(params)
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
};
